export default __webpack_public_path__ + "static/P_SearchThumb_IN-W2-dca1f0ad5f882062978d31ca3f662fca.webp";